// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__393Ub","text":"SelectPayment_text__2fIDO","title":"SelectPayment_title__2Ockv","btn":"SelectPayment_btn__b7wkn"};